export { default } from "bullitttime-embermodelsevent/adapters/eventModelsAdapter";
